import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { Redirect } from 'react-router';
import { CartPart, ConfigurationModel } from 'franke-trough-dependencies';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './CheckoutParts.messages';
import { userIsInternal, userIsSalesRep } from 'src/app/Partials/Admin/utils';
import { Link } from 'react-router-dom';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface CheckoutButtonProps {
  clientInfo: GlobalPrivateState['clientInfo'];
  configuration: GlobalPrivateState['configuration'];
  dispatch: Function;
  location: GlobalPrivateState['router']['location'];
  checkout: GlobalPrivateState['checkout'];
  order: GlobalPrivateState['order'];
  user: GlobalPrivateState['user'];
}

export class CheckoutButtonPartial extends React.Component<CheckoutButtonProps, any> {
  constructor(props: CheckoutButtonProps) {
    super(props);

    this.state = {
      submitAs: this.currentStatus === 'offer' ? 'order' : 'offer'
    }
  }

  render() {
    const {
      configuration,
      location,
      order,
      user
    } = this.props;
  
    const succeededUrl = '/thank-you';
    
    const isInternalUser = user.result && userIsInternal(user.result);
    const isSalesRepUser = user.result && userIsSalesRep(user.result);

    const isDraft = this.currentStatus === 'draft';
    const isRequest = this.currentStatus === 'request';
    const isOffer = this.currentStatus === 'offer';
    const isOrder = this.currentStatus === 'order';

    const hasSapQueued = (order.error && order.error.code === 'SAP_QUEUED') || (configuration.result && configuration.result.completionStatus === 'queued');

    return (
      <>
        {!order.updating && order.loaded && order.result && location.pathname !== succeededUrl && (
          <Redirect to={succeededUrl} />
        )}
        {hasSapQueued ? (
          <div className="col-12 mb-3 text-red">
            <FormattedMessage {...MESSAGES.orderIsQueued} />
          </div>
        ) : (
          <>
            {!isInternalUser && !isSalesRepUser && !isRequest && (
              <div className="col-12 mb-3">
                <button 
                  disabled={order.updating || order.loaded ? true : false}
                  className="btn btn-secondary w-100"
                  onClick={() => this.dispatchOrder('request')}
                >
                  <FormattedMessage {...MESSAGES.submitAsRequest} />
                </button>
              </div>
            )}
            {(isInternalUser || isSalesRepUser) && !isOffer && !isOrder && (
              <div className="col-12 mb-3">
                <button 
                  disabled={order.updating || order.loaded ? true : false}
                  className="btn btn-secondary w-100"
                  onClick={() => this.dispatchOrder('offer')}
                >
                  <FormattedMessage {...MESSAGES.submitAsOffer} />
                </button>
              </div>
            )}
            {(isInternalUser) && !isOrder && (
              <div className="col-12 mb-3">
                <button 
                  disabled={order.updating || order.loaded ? true : false}
                  className="btn btn-secondary w-100"
                  onClick={() => this.dispatchOrder('order')}
                >
                  <FormattedMessage {...MESSAGES.submitAsOrder} />
                </button>
              </div>
            )}
          </>
        )}
        {order.error && order.error.message && (
          <div className="col-12 mb-3 text-red">
            {this.isJsonString(order.error.message) ? JSON.parse(order.error.message).message : order.error.message}
          </div>
        )}
      </>
    );
  }

  onChangeStatus = (e: any) => {
    this.setState({
      submitAs: e.target.checked ? 'order' : 'offer'
    })
  }

  isJsonString = (str: string) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  dispatchOrder = (
    submitAs: ConfigurationModel['completionStatus'] = 'offer',
  ): void => {
    const {
      configuration,
      dispatch,
      checkout
    } = this.props;

    const isoCode = configuration.result && configuration.result.country;
    const configurationId = configuration.result && configuration.result.id;
    const orderId = configuration.result && configuration.result.orderId;
    const parts = checkout.result && checkout.result.lines && checkout.result.lines.parts;

    const qtys: object[] = [];
  
    if (parts) {
      for (const partLine of parts) {
        const part = partLine.part as CartPart;
        qtys.push({qty: partLine.qty, id: part.id || ''});
      }
    }

    if (configurationId && isoCode && submitAs) {
      let url = `/Orders/${configurationId}/create-order?code=${isoCode.toUpperCase() || 'DE'}&completionStatus=${submitAs}`;

      if (orderId) {
        url = `/Orders/${configurationId}/switch-status?completionStatus=${submitAs}`;
      }

      dispatch(requestAPIActions.load<RequestApiHttpPayload>('order', {
        url: url,
        options: {
          method: 'POST',
          data: !orderId ? qtys : undefined,
        }
      }));
    }
  }

  get currentStatus() {
    const currentStatus = (this.props.configuration.result && this.props.configuration.result.completionStatus) || 'draft';
    return currentStatus;
  }
}


export const CheckoutButton = connect((state: GlobalPrivateState) => ({
  clientInfo: state.clientInfo,
  configuration: state.configuration,
  location: state.router.location,
  order: state.order,
  checkout: state.checkout,
  user: state.user
}))(CheckoutButtonPartial);

export default CheckoutButton;